// extracted by mini-css-extract-plugin
export default {"basketHeader":"BasketHeader_basketHeader__YxI6e","navigationLinks":"BasketHeader_navigationLinks__zAlGE","navigationLink":"BasketHeader_navigationLink__wYFXF"};